module.exports = __webpack_public_path__ + "img/CX.ea59995d.png";